import axios from 'axios';
import qs from 'qs';

const baseUrl = window.location.origin;

export const instance = axios.create({
  withCredentials: false,
  baseURL:
    baseUrl.includes('localhost') || baseUrl.includes('192.168.')
      ? 'https://test.edem-v-gosti.ru/lk/api/'
      : `${baseUrl}/lk/api/`,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('egApiToken');
  if (token && !instance.defaults.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (config) => config,
  (error) => {
    if (error.response.status === 400) {
      localStorage.removeItem('egApiToken');
      delete instance.defaults.headers['Authorization'];
      window.location.replace('/login');
    }
    return Promise.reject(error);
  },
);

export const appAPI = {
  getMessengers: () => instance.post(`/messenger/getList`).then((response) => response.data),
};

export const userAPI = {
  getUser: () => instance.post(`/user/getUser`).then((response) => response.data),

  login(formValues) {
    return instance.post(`/user/signIn`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },
  logout() {
    return instance.post(`/user/logout`).then((response) => {
      return response.data;
    });
  },

  signUp(formValues) {
    return instance.post(`/user/signUp`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },
  checkUserExist(formValues) {
    return instance.post(`/user/checkUserExist`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },
  update(formValues) {
    formValues['data'] = JSON.stringify(formValues['data']);
    return instance.post(`/user/update`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },
  confirmRegistration(formValues) {
    return instance.post(`/user/confirmRegistration`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },
  sendUserConfirmation(formValues) {
    return instance
      .post(`/user/sendUserConfirmation`, qs.stringify(formValues))
      .then((response) => {
        return response.data;
      });
  },
  passwordChangeRequest(formData) {
    return instance.post(`/user/passwordChangeRequest`, qs.stringify(formData)).then((response) => {
      return response.data;
    });
  },
  changePassword(formData) {
    return instance.post(`/user/changePassword`, qs.stringify(formData)).then((response) => {
      return response.data;
    });
  },
  getAccess2Object(formData) {
    return instance.post(`/user/getAccess2Object`, qs.stringify(formData)).then((response) => {
      return response.data;
    });
  },
  getAccess2ObjectAuth(formData) {
    return instance.post(`/user/getAccess2ObjectAuth`, qs.stringify(formData)).then((response) => {
      return response.data;
    });
  },
};

export const mapsApi = {
  getCountries() {
    return instance.post(`/search/getCountryList`).then((response) => {
      return response.data;
    });
  },
  getCities(params) {
    return instance.post(`/search/getCityList`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  geoCode(params) {
    return instance.post(`/search/geoCode`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getCatalogList(params) {
    return instance.post(`/search/getCatalogList`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
};

export const objectsApi = {
  getObjectsList() {
    return instance.post(`/objects/getList`).then((response) => {
      return response.data;
    });
  },

  searchObjects(formValues) {
    return instance.post(`/objects/getList`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },
  getNavParams(formValues) {
    return instance.post(`/objects/getNavParams`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },

  getById(formValues) {
    return instance.post(`/objects/getById`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },
  update(formValues) {
    formValues['data'] = JSON.stringify(formValues['data']);
    return instance.post(`/objects/update`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },

  // !
  saveObjectPhotos(formValues) {
    return instance.post(`/objects/update`, formValues).then((response) => {
      return response.data;
    });
  },

  getTypes() {
    return instance.post(`/objects/getTypeList`).then((response) => {
      return response.data;
    });
  },
  addObject(formValues) {
    return instance.post(`/objects/add`, qs.stringify(formValues)).then((response) => {
      return response.data;
    });
  },
  getContractInfo(formData) {
    return instance.post(`/objects/getContractInfo`, qs.stringify(formData)).then((response) => {
      return response.data;
    });
  },
  getContractFields(formData) {
    return instance.post(`/objects/getContractFields`, qs.stringify(formData)).then((response) => {
      return response.data;
    });
  },
  setNextStage(formData) {
    return instance.post(`/objects/setNextStage`, qs.stringify(formData)).then((response) => {
      return response.data;
    });
  },
  downloadContract(formData) {
    return instance
      .get(`/objects/downloadContract?object=${formData.object}&country=${formData.country}`, {
        responseType: 'blob',
      })
      .then((response) => {
        return window.URL.createObjectURL(new Blob([response.data]));
      });
  },
  getReviewsList(params) {
    return instance.post(`/objects/getReviewsList`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getReviewsNavParams(params) {
    return instance.post(`/objects/getReviewsNavParams`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getChannelManagerList() {
    return instance.post(`/objects/getChannelManagerList`).then((response) => {
      return response.data;
    });
  },
  checkDealBind(params) {
    return instance.post(`/objects/checkDealBind`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getEntityInfoByInn(params) {
    return instance.post(`/objects/getEntityInfoByInn`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
};

export const bookingApi = {
  getList(params) {
    return instance.post(`/booking/getList`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getStatusList(params) {
    return instance.post(`/booking/getStatusList`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getNavParams(params) {
    return instance.post(`/booking/getNavParams`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getBooking(bookingId) {
    return instance
      .post(`/booking/getById`, qs.stringify({ orderId: bookingId }))
      .then((response) => {
        return response.data;
      });
  },
  setStatus(data) {
    return instance.post(`/booking/setStatus`, qs.stringify(data)).then((response) => {
      return response.data;
    });
  },
};

export const roomsApi = {
  getRoomById(params) {
    return instance.post(`/room/getById`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getList(params) {
    return instance.post(`/room/getList`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getTypeList() {
    return instance.post(`/room/getTypeList`).then((response) => {
      return response.data;
    });
  },
  getAvailability(room) {
    return instance.post(`/room/getAvailability`, qs.stringify(room)).then((response) => {
      return response.data;
    });
  },
  updateAvailability(availability) {
    return instance
      .post(`/room/updateAvailability`, qs.stringify(availability))
      .then((response) => {
        return response.data;
      });
  },
  addRoom(formData) {
    return instance.post(`/room/add`, formData).then((response) => {
      return response.data;
    });
  },
  updateRoom(formData) {
    return instance.post(`/room/update`, formData).then((response) => {
      return response.data;
    });
  },
  getFields(formValue) {
    return instance.post(`/room/getFields`, qs.stringify(formValue)).then((response) => {
      return response.data;
    });
  },
  getPriceTypes() {
    return instance.post(`/room/getPriceTypes`).then((response) => {
      return response.data;
    });
  },
};

export const pricesAPI = {
  getSubscriberList(id) {
    return instance.post(`/price/getSubscriberList`, qs.stringify(id)).then((response) => {
      return response.data;
    });
  },
  getCommissionList(id) {
    return instance.post(`/price/getCommissionList`, qs.stringify(id)).then((response) => {
      return response.data;
    });
  },
  updateCommission(prices) {
    return instance.post(`/price/updateCommission`, qs.stringify(prices)).then((response) => {
      return response.data;
    });
  },
  updateSubscriber(prices) {
    return instance.post(`/price/updateSubscriber`, qs.stringify(prices)).then((response) => {
      return response.data;
    });
  },
  updateSalesActive(prices) {
    return instance.post(`/price/updateSalesActive`, qs.stringify(prices)).then((response) => {
      return response.data;
    });
  },
};

export const invoicesAPI = {
  getPages(params) {
    return instance.post(`/invoice/getPages`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getInvoiceList(params) {
    return instance.post(`/invoice/getInvoiceList`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getStatusList() {
    return instance.post(`/invoice/getStatusList`).then((response) => {
      return response.data;
    });
  },
};

export const historyAPI = {
  getList(params) {
    return instance.post(`/log/getList`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
  getHistoryNav(params) {
    return instance.post(`/log/getNavParams`, qs.stringify(params)).then((response) => {
      return response.data;
    });
  },
};
